import React, { Component } from 'react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

class PhoneField extends Component {
  static defaultProps = {
    input: {
      value: '',
      onFocus: () => null,
      onBlur: () => null,
    },
    meta: {},
  }

  render() {
    const {
      input,
      meta: { touched, error },
      label,
    } = this.props
    return (
      <div className="md-field">
        <div className="phoneField">
          {label && <label>{label}</label>}
          <PhoneInput
            {...this.props}
            onBlur={() => input.onBlur()}
            onFocus={() => input.onFocus()}
            value={input.value.phone}
            onChange={(phone = '', country) =>
              input.onChange({
                phone,
                country,
                dialCode: country.dialCode,
                localPhone: phone.replace(`+${country.dialCode}`, ''),
              })
            }
            country={'es'}
            preferredCountries={['es']}
          />
        </div>
        {touched && error && <span className="error">{error}</span>}
      </div>
    )
  }
}

export default PhoneField
